import React, { createContext, useContext, useEffect, useState, useCallback, useRef } from 'react';
import { api } from './api';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);
  const versionRef = useRef(0);

  const load = useCallback(async () => {
    const myVersion = ++versionRef.current;
    const t = localStorage.getItem('token');
    if (!t) { if (versionRef.current === myVersion) { setUser(null); setReady(true); } return; }
    try {
      const { data } = await api.get('/auth/me');
      if (versionRef.current === myVersion) setUser(data.user);
    } catch {
      if (versionRef.current === myVersion) {
        localStorage.removeItem('token');
        setUser(null);
      }
    } finally {
      if (versionRef.current === myVersion) setReady(true);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    versionRef.current++; // invalidate any in-flight /auth/me
    localStorage.setItem('token', data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post('/auth/register', payload);
    versionRef.current++;
    localStorage.setItem('token', data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    versionRef.current++; // invalidate any in-flight /auth/me
    localStorage.removeItem('token');
    setUser(null);
  };

  const refresh = async () => { await load(); };

  return (
    <AuthCtx.Provider value={{ user, ready, login, register, logout, refresh, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);

export function dashboardPathFor(role) {
  switch (role) {
    case 'super_admin':
    case 'admin': return '/admin';
    case 'employee': return '/employee';
    case 'business_owner': return '/owner';
    default: return '/';
  }
}
